import { z } from "zod"

/**
 * The first-run setup steps, in the order they are shown. The server decides
 * which of these apply to a given viewer (role and plan both narrow the list),
 * so the client renders whatever array it is handed rather than re-deriving
 * applicability from entitlements it may not have loaded.
 */
export const ApiSetupStepKeySchema = z.enum([
  "upload_document",
  "forward_document",
  "quickbooks_destination",
  "invite_teammate",
])

export type ApiSetupStepKey = z.infer<typeof ApiSetupStepKeySchema>

export const ApiSetupStepSchema = z.object({
  key: ApiSetupStepKeySchema,
  done: z.boolean(),
})

export type ApiSetupStep = z.infer<typeof ApiSetupStepSchema>

/** Only the steps that apply to this viewer, in step-key order. An empty array
 * means there is nothing left to set up, which the client treats the same way
 * it treats every step being done: no panel. */
export const ApiSetupProgressResponseSchema = z.object({
  steps: z.array(ApiSetupStepSchema),
})

export type ApiSetupProgressResponse = z.infer<
  typeof ApiSetupProgressResponseSchema
>
